import { cx } from '@twind/core';
import React from 'react';

export default function TailorFaqButton({
  href,
  target,
  onClick,
  rel = 'noreferrer',
  className,
  buttonStyle = 'primary',
  iconEnabled,
  iconUrl,
  buttonText,
}: {
  href: string;
  target: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  rel?: string;
  className?: string;
  buttonStyle?: 'primary' | 'secondary';
  iconEnabled?: boolean;
  iconUrl?: string;
  buttonText: string;
}) {
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      onClick={onClick}
      className={cx(`faq-button-${buttonStyle}`, '~(w-full flex items-center whitespace-pre-line)', className)}
    >
      {iconEnabled && (
        <img
          src={iconUrl}
          alt="faq button icon"
        />
      )}
      {buttonText}
    </a>
  );
}
